import React, { useEffect, useState } from "react";
import OfferCard from "../../components/cards/OfferCard";
import BlogCard from "../../components/cards/BlogCard";
import ImageSlider from "../../components/elements/ImageSlider";
import MobileHeader from "../../layout/MobileHeader";
import axios from 'axios'

import MobileHeaderSearch from "../../components/MobileHeaderSearch";
import { dateFormat } from "../../utils";
import { SwiperSlide } from "swiper/react";
import { useNavigate } from "react-router-dom";


const BlogDetails = ({ blog = {}, blogs = [] }) => {
  const navigate = useNavigate()
  return (
    <>
      <MobileHeader height={"237px"} >
          <MobileHeaderSearch placeholder="Search for blogs and Stories" onSearch={( value ) => navigate(`/blogs?search=${ value }`)} />
      </MobileHeader>

      <section className="blog-details mobile-top-space">
        <div className="px-2">
          <ImageSlider pagination={{ clickable: true }}>
            {
              blog?.files?.map((file, i) =>
                <SwiperSlide key={i}>
                  <div style={{ height: "250px" }}>
                    <img src={file?.Url} className="w-100 h-100 image-cover rounded-3" />
                  </div>
                </SwiperSlide>
              )
            }
          </ImageSlider>
        </div>

        <div className="container">
          <div className="d-flex align-items-center my-4">
            <p className="text-primary mb-1 me-3 fs-9 ">
              <span
                className="dot me-2 bg-primary me-1 "
                style={{
                  height: "8px",
                  width: "8px",
                  borderRadius: "50%",
                  display: "inline-block",
                }}
              ></span>
              { dateFormat( blog.createdAt )}
            </p>
            <p className="text-primary mb-1 fs-9">
              <span
                className="dot me-2 bg-primary me-1 "
                style={{
                  height: "8px",
                  width: "8px",
                  borderRadius: "50%",
                  display: "inline-block",
                }}
              ></span>
              { blog.cityId?.name }
            </p>
          </div>

          <div className="top-heading text-saffron mb-2">
            { blog.title }
          </div>

          <p dangerouslySetInnerHTML={{ __html: blog?.content }}></p>

          <h2 className="custom-text-color my-5">Similar Blogs</h2>

          {/* blogs */}
          <div className="d-flex row flex-nowrap overflow-auto scrollbar-hidden">
            {blogs.map((blog) => (
              <div className="col-10">
                <div className="m-2">
                  <BlogCard data={blog} />
                </div>
              </div>
            ))}
          </div>

          {/* offers */}
          <div className="offers">
            <div className="row mx-0 px-5 pt-5">
              <div className="col-md-8 p-0">
                <div className="top-heading">Offers Tailored For You</div>
              </div>
              <div className="col-md-4 d-flex justify-content-end">
                <div className="view-all w-50">Know More</div>
              </div>
            </div>

            <div className="row  mx-0 my-5 ">
              <ul className="list-unstyled d-flex offers-card-list-mobile  mobileScrollBar">
                <li className="m-2">
                  <div className="bg-dark rounded offers-card-container">
                    <OfferCard
                      data={"Get upto 15% off on your First Booking"}
                    />
                  </div>
                </li>

                <li className="m-2">
                  <div className="bg-dark rounded offers-card-container">
                    <OfferCard data={"Budget Friendly Homestays"} />
                  </div>
                </li>
              </ul>

              <div className="col-md-6 d-flex justify-content-start sm-justify-content-end"></div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogDetails;
